// src/App.js
import { BrowserRouter as Router, Routes } from "react-router-dom";
import PublicRoutes from "./routes/PublicRoutes";
import AdminRoutes from "./routes/AdminRoutes";
import SellerRoutes from "./routes/SellerRoutes";
import "./App.css";
function App() {
  return (
    <Router>
      <Routes>
        {PublicRoutes()}
        {AdminRoutes()}
        {SellerRoutes()}
      </Routes>
    </Router>
  );
}

export default App;
